import { rem } from '@vimeo/bokeh';

import { BannerAlignment, HoverStateType } from './types';

export const getGridTemplateBreakpointValue = (showVideoPlayerCards?: boolean) => ({
  base: `repeat(auto-fill, minmax(${showVideoPlayerCards ? '18rem' : '16rem'}, 1fr))`,
  sm: `repeat(auto-fill, minmax(${showVideoPlayerCards ? '23rem' : '16rem'}, 1fr))`,
});

export const BANNER_GRADIENTS: Record<BannerAlignment, string> = {
  center: 'linear-gradient(180deg, transparent 0%, black 100%)',
  right: 'linear-gradient(90deg, transparent 0%, black 100%)',
  left: 'linear-gradient(90deg, black 0%, transparent 100%)',
};

const getPreviewHoverStyles = (
  isShowcasePreview: boolean | undefined,
  isActiveState: boolean,
  type: HoverStateType,
) =>
  isShowcasePreview && !isActiveState
    ? {
        transition: 'border-color 200ms ease-in-out',
        borderColor: 'fill-brand',
        [`[data-component-id="${type}-hover-wrapper"]`]: { opacity: 1 },
      }
    : undefined;

export const getBorderStyles = (
  isShowcasePreview: boolean | undefined,
  isActiveState: boolean,
  type: HoverStateType,
) => ({
  border: `${rem(2)} solid`,
  borderColor: isActiveState ? 'fill-brand' : 'transparent',
  _focusWithin: getPreviewHoverStyles(isShowcasePreview, isActiveState, type),
  _hover: getPreviewHoverStyles(isShowcasePreview, isActiveState, type),
  sx: isActiveState
    ? {
        [`[data-component-id="${type}-hover-wrapper"]`]: { visibility: 'hidden' },
      }
    : undefined,
});

export const commonWrapperWidth = {
  base: '100%',
  md: `calc(100% + ${rem(32)})`,
  lg: `calc(100% + ${rem(48)})`,
};
export const commonWrapperLeft = { base: 0, md: rem(-16), lg: rem(-24) };
